(()=>{
  'use strict';
  const q=(s,r=document)=>r.querySelector(s), qa=(s,r=document)=>[...r.querySelectorAll(s)];
  const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const threshold=q('[data-threshold]');
  const enter=q('[data-enter-world]');
  const setWorldInert=locked=>{
    [q('[data-site-header]'),q('#MainContent')].forEach(el=>{
      if(!el)return;
      if(locked){el.setAttribute('inert','');el.setAttribute('aria-hidden','true')}
      else{el.removeAttribute('inert');el.removeAttribute('aria-hidden')}
    });
  };
  const finishEntrance=(skipAnimation=false)=>{
    if(!threshold)return;
    document.body.classList.remove('threshold-active');
    setWorldInert(false);threshold.setAttribute('aria-hidden','true');
    try{sessionStorage.setItem('ehyeh_entered','1')}catch(_){ }
    if(skipAnimation||reduced){threshold.classList.add('is-hidden');q('#MainContent')?.focus({preventScroll:true});return}
    threshold.classList.add('is-leaving');
    window.setTimeout(()=>{threshold.classList.add('is-hidden');q('#MainContent')?.focus({preventScroll:true})},820);
  };
  if(threshold){
    let already=false;
    try{already=sessionStorage.getItem('ehyeh_entered')==='1'}catch(_){ }
    if(already){threshold.classList.add('is-skipped');threshold.setAttribute('aria-hidden','true')}
    else{document.body.classList.add('threshold-active');setWorldInert(true);window.setTimeout(()=>enter?.focus(),80)}
    enter?.addEventListener('click',()=>finishEntrance(false));window.__EHYEH_ENTRANCE_BOUND=true;
  }

  const header=q('[data-site-header]');
  const nav=q('[data-site-nav]');
  const toggle=q('[data-nav-toggle]');
  const mobileNav=window.matchMedia?.('(max-width: 1360px)');
  const setNav=requestedOpen=>{
    const mobile=!!mobileNav?.matches;const open=mobile&&!!requestedOpen;
    nav?.classList.toggle('is-open',open);toggle?.setAttribute('aria-expanded',String(open));document.body.classList.toggle('nav-open',open);
    if(nav){if(mobile&&!open){nav.setAttribute('inert','');nav.setAttribute('aria-hidden','true')}else{nav.removeAttribute('inert');nav.removeAttribute('aria-hidden')}}
  };
  setNav(false);
  toggle?.addEventListener('click',()=>setNav(!nav?.classList.contains('is-open')));
  qa('a',nav).forEach(a=>a.addEventListener('click',()=>setNav(false)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav?.classList.contains('is-open')){setNav(false);toggle?.focus()}});
  mobileNav?.addEventListener?.('change',()=>setNav(false));
  const onScroll=()=>header?.classList.toggle('is-scrolled',window.scrollY>24);
  onScroll();window.addEventListener('scroll',onScroll,{passive:true});

  const reveals=qa('.reveal');
  if(reduced||!('IntersectionObserver' in window)){reveals.forEach(el=>el.classList.add('is-visible'))}
  else{
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.08,rootMargin:'0px 0px -7% 0px'});
    reveals.forEach(el=>observer.observe(el));
  }

  /* Legacy browser/system TTS is deliberately retired. Old controls are redirected to the controlled AI-person book experience instead of invoking SpeechSynthesis. */
  qa('[data-reader-open]').forEach(button=>{
    const replacement=button.cloneNode(true);
    replacement.removeAttribute('data-reader-open');
    replacement.setAttribute('data-ehea-legacy-reader-retired','');
    replacement.textContent='AI-persoon · bekijk/luister';
    button.replaceWith(replacement);
    replacement.addEventListener('click',()=>{
      const localAi=replacement.closest('article,li,section,div')?.querySelector?.('[data-ehea-ai-person]');
      if(localAi&&localAi!==replacement){localAi.click();return}
      window.location.assign('/pages/bibliotheek');
    });
  });
  qa('[data-reader-dialog]').forEach(dialog=>{try{if(dialog.open&&typeof dialog.close==='function')dialog.close()}catch(_){ }dialog.remove()});
})();
